// extracted by mini-css-extract-plugin
export default {"container":"safety_container__UUpoo","text":"safety_text__45epP","logo":"safety_logo__nCywi"};